const option = window.ELEMENT.Option;
const render = option.render;
const data = option.data;

option.data = function (h) {
  let res = data.call(this);
  if (this.$parent.$options.componentName == 'ElOptionGroup') {
    res.level = this.$parent.level + 1;
  } else {
    res.level = 1;
  }
  return res;
};

option.render = function (h) {
  let vnode = render.call(this, h);
  if (!vnode.data.style) {
    vnode.data.style = {}
  }
  vnode.data.style['padding-left'] = this.level * 20 + 'px';
  return vnode;
};

Object.assign(option.props, {
  show: {
    type: Boolean,
    default: true
  }
});

option.watch['show'] = {
  handler(v) {
    this.visible = v
  }
}

